import React, { useContext } from 'react';
import { Edit as EditIcon } from '@mui/icons-material';

import { ControlWrap } from '../style';
import { SchemaDisplayContext } from '../context';

function EditTrigger(props) {
  const { id } = props;
  const { node: { onEdit } } = useContext(SchemaDisplayContext);

  return (
    <ControlWrap onClick={() => onEdit(id)}>
      <EditIcon />
    </ControlWrap>
  );
}

export default EditTrigger;
